import React, { useCallback } from 'react';
import { useOutletContext } from 'react-router-dom';

import { SEO } from '@/components/SEO';
import { EVENT_CARS_PAGE_VISITED } from '@/constants/events';
import usePageReady from '@/features/installation/hooks/usePageReady';
import { PageBuilderContextType } from '@/interfaces/constructor.interfaces';
import sendEvent from '@/utils/sendEvent';

import { CarsProps } from './Cars.types';

function Cars(props: CarsProps) {
  const { children } = useOutletContext<PageBuilderContextType>();

  const handlePageReady = useCallback(() => {
    sendEvent(EVENT_CARS_PAGE_VISITED);
  }, []);

  usePageReady({
    onReady: handlePageReady,
  });

  return (
    <>
      <SEO title="Страница списка авто" />
      {children}
    </>
  );
}

export default React.memo(Cars);
